var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.experiment)?_c('div',{class:'template-' + _vm.experiment.template_id},[(_vm.experiment.status === '1')?_c('p',[_vm._v("DRAFT")]):_vm._e(),_c('screen',{attrs:{"screen":_vm.screens[_vm.progress]}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }